import { Component, OnInit } from '@angular/core';
import {
  DatatableActionButton, DatatableEvent,
  DatatableHandler, DatatableHandlerEvents, DatatableHandlerSettings,
  IconType
} from "../../../components/datatables/datatable/datatable/datatable.component";
import {DataTableRoutes} from "../../../constants/datatableUrls";
import {Title} from "@angular/platform-browser";
import {SimpleModalService} from "ngx-simple-modal";
import {ToastrService} from "ngx-toastr";
import {ErrorProcessorService} from "../../../services/error-processor.service";
import {TenantService} from "../../../services/tenant.service";
import {SubjectsClient} from "../../../generated-client/generated-api-client";
import { PersistentDataService } from '../../../services/persistent-data.service';

@Component({
  selector: 'app-subject-list',
  templateUrl: './subject-list.component.html',
  styleUrls: ['./subject-list.component.sass']
})
export class SubjectListComponent {

  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const id = data['id'];
    const isArchived = data['isArchived'];

    const editUrl = `/subjects/${id}`;
    const editAction = new DatatableActionButton('edit', 'Vizsgatárgy szerkesztése', 'edit', editUrl, IconType.Normal, isArchived);
    return [
      editAction,
    ];
  };

  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtEvents: DatatableHandlerEvents = DatatableHandler.getDefaultEvents();
  dtDataSourceUrl: string = DataTableRoutes.SubjectsList;

  constructor(
    private _titleService: Title,
    private _modalService: SimpleModalService,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _tenantService: TenantService,
    private _subjectsClient: SubjectsClient,
    private _pDservice: PersistentDataService
  ) {
    this._titleService.setTitle('Vizsgatárgyak');

    this.dtSettings.order = [1, 'asc'];
    this.dtSettings.actions = this._dtActionButtonsFn;
    this.dtSettings.pageSize = _pDservice.examSubjectsPageSize;
    this.dtSettings.searchString = _pDservice.examSubjectsSearchString;
    this.dtSettings.buttons =
      [
        {
          text: 'Vizsgatárgyak frissítése',
          class: 'btn-primary text-white',
          action: () => {
            this._subjectsClient.syncForActiveTenant().subscribe(
              response => {
                this.dtHandler?.refresh();
                this.toastr.success('Sikeres szinkronizálás');
              },
              error => this.errorProcessorService.processError(error, true)
            );
          },
        },
      ];

    this.dtEvents.createdRow = (row: Node, data: any) => {
      if (data['isArchived']) {
        let rowElement = row as HTMLTableRowElement;
        rowElement.classList.add('archived');
      }
    };

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.examSubjectsPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.examSubjectsSearchString = this.dtHandler?.searchString
      return {
        tenantId: this._tenantService.activeTenantId,
      };
    };
  }

  onInit(dtHandler: DatatableHandler) {
    this.dtHandler = dtHandler;
    this.dtHandler.create();
  }

}
